import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {isMobileOnly, isTablet} from 'react-device-detect';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import {Container, Row, Col} from 'reactstrap';
import {
  setOtpVerifyCode,
  clearOtpCode,
  hideOtpErrorMessage,
  setRestrictedCodeValue,
  createNewOtpButtonList,
  setTermsOfUse,
} from './otpAuthenticationSlice';
import Config from '../../../Config';
import OtpInput from 'react-otp-input';
import OtpHeadlineComponent from './OtpHeadlineWrapperComponent';
import TextInput from '../../Shared/TextInput/TextInput';
import CheckBox from '../../Shared/CheckBox/Checkbox';
import CreateNewOtpButton from './CreateNewOtpButton';
import {prepareUrl} from '../../../utilities/StringHelpers/StringHelpers';
import EpiContext from '@episerver/spa-core/Spa';
import {otpReportData, otpCreateReport, enumGAReport, otpCreateGAReport} from './otpReports';
import { setRestrictedCodeError, setOtpError} from "app/utilities/authentication/authenticationSlice";

const OtpVerifyCodeComponent = (props) => {
  useEffect(() => {
    otpCreateReport(
      reportDataShowPage.Channel,
      reportDataShowPage.Area,
      reportDataShowPage.SubArea,
      reportDataShowPage.ActionType,
      reportDataShowPage.Status,
      reportDataShowPage.MessageText,
      props.otpTitles?.blockSource,
      props.otp?.otpPhoneForm?.phone
    );
    otpCreateGAReport(enumGAReport.OtpClickCodePage);

    //GA
    if (props.gaStep2Display) {
      props.gaStep2Display();
    }
  }, []);

  useEffect(() => {
    if ('OTPCredential' in window) {
      async function fetchOtp() {
        try {
          const otp = await navigator.credentials.get({
            otp: { transport: ['sms'] },
          });
          if (otp?.code) {
            handleChange(otp.code);
          }
        } catch (err) {
          console.error('Error fetching OTP:', err);
        }
      }
      fetchOtp();
    }
  }, []);

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      if (props.otp.otpCodeForm.valid === true && props.onSubmit == true) {
        handleChange('clear');
        props.clearOtpCode({verifyCode: ''});
      }
    }
  });

  const handleChange = (otp) => {
    if (props.authentication.formError.otpCodeError || props.authentication.formError.restrictedCodeError) {
      props.setRestrictedCodeError(null);
      props.setOtpError(null);
    }
    props.setOtpVerifyCode({verifyCode: otp});
  };

  const onCheck = () => {
    props.setTermsOfUse(!props.otp.termsOfUseConfirmed);
  };

  let reportDataShowPage = otpReportData?.OTPCodePageDisplayed;

  return (
    <Container className='pr-0 pl-0'>
      <Col className='col-12 pr-0 pl-0'>
        <OtpHeadlineComponent
          title={props.otpTitles?.verifyCodeTitle || 'שלחנו קוד אימות, הגיע?'}
          description={props.otpTitles?.verifyCodeDescription}
        />
      </Col>

      <Col className={`col-12 pr-0 pl-0 otp-verify-code`}>
        <Row className='h-100 d-flex flex-wrap align-items-center'>
          <Col ms={12} className={'p-0 d-flex flex-column p-0 col align-items-center'}>
            <div className='mainDiv'>
              <OtpInput
                shouldAutoFocus={true}
                value={props.otp.otpCodeForm.verifyCode}
                onChange={handleChange}
                numInputs={6}
                isInputNum={true}
                separator={<span className='inputSeparator'></span>}
                inputStyle='input-design'
                containerStyle={`mainDivInside`}
                renderInput={(inputProps, index) => (
                  <input {...inputProps} key={index} autoComplete="one-time-code" />
                )}
              />
            </div>
            {(props.authentication?.formError?.otpCodeError || props.authentication?.formError?.restrictedCodeError) && (
              <div className='error'><span>{props.authentication.formError.otpCodeError ?? props.authentication.formError.restrictedCodeError}</span></div>
            )}
            {/* show validation errors returned by validateOtpCodeHandler (from otp slice) */}
            {props.otp?.otpCodeForm?.errors?.verifyCode && (
              <div className='error'><span>{props.otp.otpCodeForm.errors.verifyCode}</span></div>
            )}
            {props.otp.numOfAttempts >= Config.verifyCodeAttemptsLimit ? <div className='error'>לא ניתן לבצע ניסיונות נוספים</div> : ''}
          </Col>
        </Row>
        {!props.otp.reloadProcess && (
          <Row>
            <Col className={`col-12 resend-wrapper`}>
              <div className='main d-flex'>
                {createNewOtpButtonList.map((button, index) => {
                  return (
                    <CreateNewOtpButton
                      key={index}
                      alt={button.alt}
                      description={button.description}
                      icon={button.icon}
                      action={() => {
                        button.id == 'sms' ? props.otpVerifyPhone(false) : props.otpVerifyPhone(true);
                      }}
                    />
                  );
                })}
              </div>
            </Col>
          </Row>
        )}
        {props.otp.restrictedCodeRequired && (
          <>
            <Row className='restricted-code-text'>
              <Col>הזינו קוד ייחודי שהגדרתם עם נציג {window.Config.brand_Name_HE}</Col>
            </Row>
            <Row className='h-100 d-flex flex-wrap align-items-center restricted-code-input'>
              <Col className='col-12 pr-0 pl-0'>
                <TextInput
                  className=''
                  name='restricted-code'
                  type='text'
                  id='restricted-code'
                  autoComplete='off'
                  placeholder={props.placeholder ?? 'קוד ייחודי'}
                  required='required'
                  value={props.otp.restrictedCode}
                  onChange={(e) => props.setRestrictedCodeValue(e.target.value)}
                />
              </Col>
            </Row>
          </>
        )}
        {props.otp.termsInd && (
          <Row className='termOfService'>
            <Col xs='1' md='1' className='termOfService__checkbox'>
              <div>
                <CheckBox
                  id='approveTerms'
                  onCheck={() => onCheck()}
                  onUncheck={() => {
                    onCheck();
                  }}></CheckBox>
              </div>
            </Col>
            <Col xs='10' md='10'>
              <p className='termOfService__link'>
                קראתי והסכמתי
                <span className='termOfService__link__url' onClick={() => prepareUrl(Config.cooperationPrivacyPolicyLink, EpiContext)}>
                  {/* URL to do */}
                  {` לתנאי השימוש `}
                </span>
                באתר
              </p>
            </Col>
          </Row>
        )}
      </Col>
    </Container>
  );
};
const mapStateToProps = (state) => {
  return {
    otp: state.otpAuthentication,
    isAuthenticated: state.authentication.loginData.isOtpAuthenticated,
    authentication: state.authentication
  };
};

const mapDispatchToProps = {
  setOtpVerifyCode,
  clearOtpCode,
  hideOtpErrorMessage,
  setRestrictedCodeValue,
  setTermsOfUse,
  setRestrictedCodeError,
  setOtpError
};

export default connect(mapStateToProps, mapDispatchToProps)(OtpVerifyCodeComponent);
